<template>
  <div>
    <div class="name email" v-if="type == 'shared_planner'">
      <vs-input
        :placeholder="$t('dash.pages.shared_planner.validator.lastname')"
        v-model="form.lastname"
      />
      <vs-input
        :placeholder="$t('dash.pages.shared_planner.validator.firstname')"
        v-model="form.firstname"
      />
      <vs-input
        :placeholder="$t('dash.pages.shared_planner.validator.email')"
        v-model="form.email"
      />
    </div>
    <div class="name" v-else-if="!noName">
      <vs-input
        :placeholder="$t('dash.pages.shared_planner.validator.name')"
        v-model="form.name"
      />
    </div>
    <div class="pages-available">
      <div class="title">
        {{ $t('dash.pages.group.available_pages') }}
        <span @click="showAllGroups = !showAllGroups">
          {{ !showAllGroups ? $t('dash.pages.show.groups') : $t('dash.pages.show.pages') }}
        </span>
      </div>
      <div class="content">
        <div class="search-page">
          <vs-input
            v-model="pageFilter"
            :class="{'input': true}"
            color="#B20564"
            class="inputx"
            icon-after="true"  icon="search"
            :placeholder="$t('dash.settings.user.label.page_filter')"
          />
        </div>
        <ul>
          <li class="page" v-for="item in listAvailablePages" :key="item.id"
                :class="[{'hide': !checkPageFilter(item), 'select': selectedToAdd.find(p => p.id == item.id) }]" @click="selectAvailable(item)">
            <div class="page-wrapper">
              <div class="page-content">
                <Tooltip :text="item.name" position="top">
                  <page-image-avatar :page="item" v-if="!showAllGroups"/>
                  <p class="page-name">{{ item.name }}</p>
                  &nbsp;
                </Tooltip>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="actions">
      <div class="all" @click="all">
        <img src="../../../assets/img/icon-RAZ.svg" alt="icon RAZ">
      </div>
      <div class="add" @click="add">
        <img src="../../../assets/img/icon-right-arrow.svg" alt="icon right arrow">
      </div>
      <div class="remove" @click="remove">
        <img src="../../../assets/img/icon-left-arrow.svg" alt="icon left arrow">
      </div>
      <div class="raz" @click="raz">
        <img src="../../../assets/img/icon-RAZ.svg" alt="icon RAZ">
      </div>
    </div>

    <div class="pages-affected">
      <div class="title">{{ $t(type === 'source_to_page' || type === 'pages_to_user' ? 'dash.pages.selected' : 'dash.pages.group.in_group') }}</div>
      <div class="content">
        <ul>
          <li class="page" v-for="(item, index) in form.pages" :key="item.id"
                :class="[{'select': selectedToRemove.find(p => p.id == item.id) }]" @click="selectAffected(item)">
            <div class="page-wrapper">
              <div class="page-content">
                <Tooltip :text="item.name" position="top">
                  <page-image-avatar :page="item"/>
                  <p class="page-name">{{ item.name }}</p>
                  &nbsp;
                </Tooltip>
              </div>
              <div class="position">
                <div class="top" :class="[{'disable': index == 0}]" @click="changePosition(index, index-1)">
                  <img alt="top" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
                </div>
                <div class="bottom" :class="[{'disable': index == form.pages.length-1}]" @click="changePosition(index, index+1)">
                  <img alt="bottom" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="submit">
      <vs-button 
        class="validate"
        @click="submit"
        color="#6a1f4c">
        <p>{{ $t('dash.pages.overlay.validate') }}</p>
      </vs-button> 
    </div>

  </div>
</template>

<script>

import PageImageAvatar from '../PageImageAvatar.vue'
import Tooltip from './../tooltip/tooltipInit.vue'

export default {
  name: 'component-pages-selector',

  components: {
    PageImageAvatar,
    Tooltip
  },

  props: {
    allPages: Array,
    groups: Array,
    noName: { type: Boolean, default: false },
    pagesAdded: Array,
    type: String
  },

  data() {
    return {
      pages: [],
      form: {
        name: null,
        pages: [],
        lastname: null,
        firstname: null,
        email: null
      },
      pageFilter: '',
      selectedToAdd: [],
      selectedToRemove: [],
      showAllGroups: false
    }
  },

  computed: {
    listAvailablePages() {
      return this.showAllGroups ? this.groups : this.pages
    }
  },

  mounted() {
    this.pages = this.allPages && this.allPages.length ? this.allPages : (localStorage.pages && JSON.parse(localStorage.pages) ? JSON.parse(localStorage.pages) : [])
    
    let user = localStorage.user && JSON.parse(localStorage.user) ? JSON.parse(localStorage.user) : null
    //if role editor (!admin & no role)
    if(user && !user.admin && (!user.role || user.role.length == 0))
      this.pages = [...this.pages.filter(page => user.pages_access.some(p => p == page.id))]

    this.form.pages = this.pagesAdded && this.pagesAdded.length ? [...this.pagesAdded] : []
  },

  methods: {
    
    /** check page filter **/
    checkPageFilter(page){
      if(this.showAllGroups){
        if(page.pages.every(id => this.form.pages.find(p => p.id == id)))
          return false

        return page.name.toLowerCase().includes(this.pageFilter.trim().toLowerCase())
                  || page.pages.every(id => this.pages.find(p => p.id == id).name.toLowerCase().includes(this.pageFilter.trim().toLowerCase()))
                  || page.pages.every(id => this.pages.find(p => p.id == id).network.toLowerCase().includes(this.pageFilter.trim().toLowerCase()))
      }
      else {
        if(this.form.pages.find(p => p.id == page.id))
          return false
        
        return page.name.toLowerCase().includes(this.pageFilter.trim().toLowerCase()) || page.network.toLowerCase().includes(this.pageFilter.trim().toLowerCase()) 
      }

    
    },

    changePosition(fromIndex, toIndex) {
      if(toIndex >= 0 && toIndex < this.form.pages.length){
        let element = this.form.pages[fromIndex];
        this.form.pages.splice(fromIndex, 1);
        this.form.pages.splice(toIndex, 0, element);
      }
    },

    selectAffected(page){
      this.selectedToAdd = []
      if(this.selectedToRemove.find(p => p.id == page.id))
        this.selectedToRemove = this.selectedToRemove.filter(p => p.id != page.id)
      else
        this.selectedToRemove.push(page)
    },
    
    selectAvailable(page){
      this.selectedToRemove = []
      if(this.selectedToAdd.find(p => p.id == page.id))
        this.selectedToAdd = this.selectedToAdd.filter(p => p.id != page.id)
      else
        this.selectedToAdd.push(page)
    },

    add() {
      if(this.selectedToAdd.length) {
        if(this.showAllGroups){
          for(let group of this.selectedToAdd) {
            for(let page of group.pages){
              if(!this.form.pages.find(p => p.id == page) && this.pages.find(p => p.id == page))
                this.form.pages.unshift(this.pages.find(p => p.id == page))
            }
          }
        }
        else {
          for(let page of this.selectedToAdd)
            this.form.pages.unshift(page)
        }
        this.selectedToAdd = []
      }
    },

    remove() {
      if(this.selectedToRemove.length) {
        for(let page of this.selectedToRemove)
          this.form.pages = this.form.pages.filter(p => p.id != page.id)
        this.selectedToRemove = []
      }
    },

    raz() {
      this.form.pages = []
    },

    all() {
      this.form.pages = this.form.pages.concat(this.listAvailablePages.filter(item => this.checkPageFilter(item)))
    },

    submit() {
      if(this.type == 'shared_planner') {
        if(this.form.lastname && this.form.lastname != ''
                  && this.form.firstname && this.form.firstname != ''
                  && this.form.email && this.form.email != '') {
          this.$emit('submit', {
            lastname: this.form.lastname,
            firstname: this.form.firstname,
            email: this.form.email,
            pages: this.form.pages.map(p => p.id)
          })
        }
      }
      else if(((this.form.name && this.form.name != '') || this.noName) 
              && (this.form.pages.length || ['source_to_page', 'pages_to_user'].includes(this.type))) {
        this.$emit('submit', {
          name: this.form.name,
          pages: this.form.pages.map(p => p.id)
        })
      }
    }
  }
}
</script>
